import { BooleanSwitchValue } from "consts/general";
import { useSettings } from "hooks";
import ShoppingPlatforms from "features/ecommerce/ShoppingPlatforms";
import type { MerchantSettings } from "features/merchants/types";

const usePlatformStatus = () => {
    const { getSettings } = useSettings<MerchantSettings>();

    const { platforms } = getSettings();

    return ShoppingPlatforms
        .make(platforms ?? JSON.stringify(ShoppingPlatforms.supportedPlatforms))
        .parse()
        .toEntries()
        .map(([name]) => ({
            name,
            value: BooleanSwitchValue.On
        }))
};

export default usePlatformStatus;
